import clsx from 'clsx';
import React from 'react';

import { Button, Tooltip } from 'ui';

import FeedbackModal from '../FeedbackModal/FeedbackModal';
import useSidebarFeedback from './useSidebarFeedback';

import './_sidebar-feedback.scss';

/**
 * SidebarFeedback - Sidebar block that invites teachers and students to share
 * product feedback. Expanded it shows a short prompt plus a full-width button;
 * collapsed it degrades to an icon-only button with a tooltip.
 */

type SidebarFeedbackProps = {
  isCollapsed?: boolean;
};

function SidebarFeedback({ isCollapsed = false }: Readonly<SidebarFeedbackProps>): JSX.Element {
  const { closeModal, ctaLabel, isModalOpen, openModal, promptText } = useSidebarFeedback();

  return (
    <div className={clsx('sidebar-feedback', { 'sidebar-feedback--collapsed': isCollapsed })}>
      {isCollapsed ? (
        <Tooltip placement="right" title={ctaLabel}>
          <Button ariaLabel={ctaLabel} isIconOnly leftIcon="feedback" onClick={openModal} size="sm" variant="secondary" />
        </Tooltip>
      ) : (
        <>
          <p className="sidebar-feedback__prompt">{promptText}</p>
          <Button isFullWidth onClick={openModal} size="sm" text={ctaLabel} variant="secondary" />
        </>
      )}

      <FeedbackModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default SidebarFeedback;
